<template>
  <b-sidebar
    id="add-new-event-sidebar"
    :visible="isAddNewEventSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-event-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        v-if="eventData"
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ button_text }} New Event</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <b-col
        cols="12"
        v-if="eventData.image_url"
        class="d-flex justify-content-center"
      >
        <img style="width: 100%; max-width: 300px" :src="eventData.image_url" />
      </b-col>
      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <span
            style="
              margin-bottom: 0.2857rem;
              color: #5e5873;
              font-size: 0.857rem;
            "
            >Event Image</span
          >
          <el-upload
            class="avatar-uploader"
            list-type="picture-card"
            ref="upload"
            :action="uploadUrl"
            :headers="headerObj"
            name="image_file"
            :file-list="fileList"
            multiple
            :limit="1"
            :data="eventData"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :on-change="onChange"
            :before-remove="beforeRemove"
            :on-remove="toggleUpload"
            :auto-upload="false"
            :class="{ hideUpload: !showUpload }"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <b-form-group label="Slug" label-for="slug">
              <b-form-input
                id="slug"
                v-model="eventData.slug"
                autofocus
                trim
                placeholder="Enter a unique identifier (slug)"
              />
            </b-form-group>
          <b-form-group label="Has Information?" label-for="has_information">
            <b-form-checkbox
              :checked="eventData.has_information"
              name="has_information"
              :value="1"
              :unchecked-value="0"
              switch
              inline
              v-model="eventData.has_information"
            >
              {{ eventData.has_information ? "Yes" : "No" }}
            </b-form-checkbox>
          </b-form-group>
          <div v-if="eventData.has_information">
            <!-- Event TITLE -->


            <!-- Event TITLE -->
            <b-form-group label="Event Title" label-for="event_title">
              <b-form-input
                id="event_title"
                v-model="eventData.title"
                autofocus
                trim
                placeholder="Event Title"
              />
            </b-form-group>

            <!-- Event CONTENT -->
            <b-form-group
              label="Event Description"
              label-for="event_description"
            >
              <b-form-textarea
                id="event_description"
                v-model="eventData.description"
                autofocus
                trim
                rows="3"
                placeholder="Event Description"
              />
            </b-form-group>

            <!-- Event CONTENT -->
            <b-form-group label="Event Content" label-for="event_content">
              <TinyMCEEditor :key="trigger" :content.sync="eventData.content" />
            </b-form-group>
          </div>

          <b-form-group label="Sort Order" label-for="sort_order">
            <b-form-input type="number" v-model="eventData.sort_order" />
          </b-form-group>
          <b-form-group label="Is Active?" label-for="is_active">
            <b-form-checkbox
              :checked="eventData.is_active"
              name="is_active"
              switch
              inline
              v-model="eventData.is_active"
              style="margin-top: 5px"
            >
              {{ eventData.is_active ? "Active" : "Inactive" }}
            </b-form-checkbox>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ button_text }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BCol,
  BMedia,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormCheckbox,
  BImg,
  BCardText,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { getUserData } from "@/auth/utils";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import useEventsList from "./useEventsList";
import TinyMCEEditor from "@/layouts/components/TinyMCEEditor.vue";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BButton,
    vSelect,
    BCol,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormCheckbox,
    BImg,
    BCardText,
    quillEditor,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    TinyMCEEditor,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewEventSidebarActive",
    event: "update:is-add-new-event-sidebar-active",
  },
  props: {
    isAddNewEventSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    getHasInformation: {
      type: Number,
      required: true,
    }
  },
  methods: {
    hide() {
      this.$emit("update:is-add-new-event-sidebar-active", false);
    },
    toggleUpload() {
      this.showUpload = !this.showUpload;
    },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          if (this.eventData.file) {
            formData.append("image_file", this.eventData.file);
          }
          formData.append("store_id", getUserData().store_id);
          formData.append("id", this.eventData.id);
          formData.append("slug", this.eventData.slug);
          formData.append("has_information", this.eventData.has_information);
          if (this.eventData.has_information) {
              formData.append("title", this.eventData.title);
              formData.append("description", this.eventData.description);
              formData.append("content", this.eventData.content);
          }else{
              formData.append("title", null);
              formData.append("description", null);
              formData.append("content", null);
          }
          formData.append("sort_order", this.eventData.sort_order);
          formData.append("is_active", this.eventData.is_active ? 1 : 0);

          this.loading = true;
          store
            .dispatch("bar-event/addEvent", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.showUpload = true;
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  data() {
    return {
      required,
      alphaNum,
      isHtmlMode: false,
    };
  },
  setup(props, { emit }) {
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const upload = ref(null);
    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/event");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };
    const fileList = ref([]);
    const button_text = ref("Add");
    const showUpload = ref(true);
    const loading = ref(false);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const trigger = ref(0);

    const blankEventData = {
      id: 0,
      title: "",
      content: "",
      sort_order: 0,
      is_active: true,
      has_information: props.getHasInformation,
      image_url: "",
      slug: "",
      description: "",
    };
    watch(
      () => [props.id, props.isAddNewEventSidebarActive],
      () => {
        trigger.value++;
        /* ... */
        if (props.id > 0 && props.isAddNewEventSidebarActive) {
          store
            .dispatch("bar-event/fetchEvent", props.id)
            .then((response) => {
              eventData.value = { ...response.data.event };
              eventData.value.is_active = Boolean(eventData.value.is_active);

              if (props.id > 0) {
                button_text.value = "Edit";
              } else {
                button_text.value = "Add";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (props.id == 0) {
          eventData.value = JSON.parse(JSON.stringify(blankEventData));
          fileList.value = [];
          button_text.value = "Add";
        }
      }
    );

    const eventData = ref(JSON.parse(JSON.stringify(blankEventData)));
    const reseteventData = () => {
      eventData.value = JSON.parse(JSON.stringify(blankEventData));
      fileList.value = [];
      button_text.value = "Add";
    };

    const updateeventData = (event) => {
      eventData.value = event;
    };

    const beforeRemove = (file) => {
      eventData.value.file = null;
    };

    const onChange = (file, fileLists) => {
      fileList.value = fileLists;
      eventData.value.file = file.raw;
      showUpload.value = !showUpload.value;
    };

    const uploadSuccess = (res, file, fileList) => {
      emit("refetch-data");
      emit("update:is-add-new-event-sidebar-active", false);
      showMessage(
        "Success",
        "Successfully inserted new event.",
        "CheckIcon",
        "success"
      );
    };

    const uploadFail = (err, file, fileList) => {
      //showMessage('Fail', err, 'HeartIcon', 'danger')
      console.log("upload Fail");
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(reseteventData);

    const { showMessage } = useEventsList();

    return {
      refInputEl,
      eventData,
      //onSubmit,
      beforeRemove,
      refFormObserver,
      getValidationState,
      resetForm,
      inputImageRenderer,
      refPreviewEl,
      upload,
      uploadUrl,
      uploadSuccess,
      uploadFail,
      onChange,
      headerObj,
      updateeventData,
      fileList,
      button_text,
      showUpload,
      loading,
      trigger,
    };
  },
};
</script>


<style>
</style>